import {
  needPromiseApis
} from '@vnxjs/plugin-platform-weapp/dist/runtime-utils'
import { processApis } from '@vnxjs/shared'

declare const qq: any

const asyncApis = new Set([
  'getQQRunData',
  'requestWxPayment',
  'setAvatar',
  'shareInvite',
  'updateBookshelfReadTime'
])

export function initNativeApi (vnmf) {
  processApis(vnmf, qq, {
    needPromiseApis: new Set([...needPromiseApis, ...asyncApis])
  })
  vnmf.cloud = qq.cloud
}
